import React, { Fragment } from 'react';
import cn from 'classnames';

import Header from 'components/Header';

import brochureImage from 'assets/images/brochures.jpg';
import style from './style.scss';

const RequestBrochures = () => (
  <Fragment>
    <Header />
    <section className="container section">
      <div className="grid-container fluid portal page-brochures">
        <div className="grid-x">
          <div className="cell small-12 card-grid-container">
            <div className={cn('grid-x grid-margin-x page-header', style.pageHeader)}>
              <div className="cell small-12">
                <h3>Request Brochures</h3>
              </div>
            </div>
            <div className={cn('grid-x grid-margin-x page-header', style.pageHeader)}>
              <div className="cell small-12">
                <div className="card">
                  <div className="card-section">
                    <div className="grid-x grid-margin-x">
                      <div className="cell small-12 large-4 image">
                        <img src={brochureImage} alt="Request Brochures" />
                      </div>
                      <div className="cell small-12 large-8">
                        <h6>If you need to order new printed brochures for your office please complete the form below</h6>
                        <div className="grid-x grid-margin-x">
                          <div className="cell small-12 large-6">
                            <label>
                              <span>Business Name</span>
                              <input type="text" required />
                            </label>
                            <label>
                              <span>Full Name</span>
                              <input type="text" required />
                            </label>
                            <label>
                              <span>Phone Number</span>
                              <input type="text" required />
                            </label>
                            <label>
                              <span>Email</span>
                              <input type="text" required />
                            </label>
                            <label className="has-value">
                              <span>Specialty</span>
                              <select required="">
                                <option value="">Select...</option>
                                <option value="audiology">Audiology</option>
                                <option value="bariatics">Bariatics</option>
                                <option value="chiropractic">Chiropractic</option>
                                <option value="cosmetic">Cosmetic Surgery</option>
                                <option value="dental">Dental</option>
                                <option value="dermatology">Dermatology</option>
                                <option value="fertility">Fertility</option>
                                <option value="general-healthcare">General Healthcare</option>
                                <option value="hair-restoration">Hair Restoration</option>
                                <option value="lasik-vision">Lasik & Vision</option>
                                <option value="medical-devices">Medical Devices</option>
                                <option value="medspa">Medspa</option>
                                <option value="weight-loss">Weight Loss</option>
                              </select>
                            </label>
                          </div>
                          <div className="cell small-12 large-6">
                            <label>
                              <span>Street Address</span>
                              <input type="text" required />
                            </label>
                            <label>
                              <span>Street Address 2</span>
                              <input type="text" required />
                            </label>
                            <label>
                              <span>City</span>
                              <input type="text" required />
                            </label>
                            <div className="grid-x grid-margin-x">
                              <div className="cell small-7">
                                <label className="has-value">
                                  <span>State</span>
                                  <select id="ProductType" required="">
                                    <option value="">Select...</option>
                                    <option value="ca">California</option>
                                    <option value="il">Illinois</option>
                                    <option value="va">Virginia</option>
                                  </select>
                                </label>
                              </div>
                              <div className="cell small-5">
                                <label>
                                  <span>Zip Code</span>
                                  <input type="text" required />
                                </label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="cell small-12 padded-bottom">
                          <button className="button green large w-100">Request Brochures</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </Fragment>
);

export default RequestBrochures;



// WEBPACK FOOTER //
// ./src/containers/pages/RequestBrochures/index.js